import LibraryCatalog from '../model/LibraryCatalog';

export default class LibraryCatalogSorter {

    static sort(catalogList, indexSortType) {
        if (indexSortType == 'MANUAL') {
            return catalogList;
        } else {
            let result = catalogList.slice();

            switch (indexSortType) {
                case 'PUBLISH_DATE_NEWEST_FIRST':
                    result.sort((a,b) => a.publishDate - b.publishDate);
                    break;
                case 'PUBLISH_DATE_OLDEST_FIRST':
                    result.sort((a,b) => b.publishDate - a.publishDate);
                    break;
            }

            return result;
        }
    }

}